import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserQueryVariables = Types.Exact<{
  startDate: Types.Scalars['Date']['input'];
  endDate: Types.Scalars['Date']['input'];
}>;


export type GetCurrentUserQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly sensorExclusions: ReadonlyArray<{ readonly __typename?: 'YalperSensorExclusion', readonly id: string, readonly sensorName: string }>, readonly sensorGroups: { readonly __typename?: 'AccountsCompanySensorGroups', readonly red: ReadonlyArray<string>, readonly yellow: ReadonlyArray<string>, readonly gray: ReadonlyArray<string> }, readonly graphSensorChecks: ReadonlyArray<{ readonly __typename?: 'YalperGraphSensorCheck', readonly new: number, readonly old: number, readonly fixed: number, readonly collectedOn: string, readonly sensorName: string }>, readonly lastChecks: ReadonlyArray<{ readonly __typename?: 'YalperCheck', readonly id: string, readonly checks: number, readonly cost: number, readonly found: number, readonly new: number, readonly fixed: number, readonly sensor: { readonly __typename?: 'YalperSensor', readonly id: string, readonly name: string, readonly platform: Types.YalperPlatform, readonly isError: boolean } }>, readonly regions: ReadonlyArray<{ readonly __typename?: 'YalperRegion', readonly id: number, readonly name: string }> } | null } | null };


export const GetCurrentUserDocument = gql`
    query GetCurrentUser($startDate: Date!, $endDate: Date!) {
  currentUser {
    currentCompany {
      sensorExclusions {
        id
        sensorName
      }
      sensorGroups {
        red
        yellow
        gray
      }
      graphSensorChecks(startDate: $startDate, endDate: $endDate) {
        new
        old
        fixed
        collectedOn
        sensorName
      }
      lastChecks {
        id
        checks
        cost
        found
        new
        fixed
        sensor {
          id
          name
          platform
          isError
        }
      }
      regions {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables> & ({ variables: GetCurrentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>;